// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fRSC","footer":"styles_footer__28Fd6"};